var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.376 12.949C12.5062 13.0792 12.7173 13.0792 12.8475 12.949C12.9776 12.8188 12.9776 12.6078 12.8475 12.4776L8.36974 7.9999L12.8475 3.52216C12.9777 3.39199 12.9777 3.18093 12.8475 3.05076C12.7173 2.92058 12.5063 2.92058 12.3761 3.05076L7.89834 7.5285L3.4206 3.05076C3.29042 2.92058 3.07937 2.92058 2.94919 3.05076C2.81902 3.18093 2.81902 3.39199 2.94919 3.52216L7.42694 7.9999L2.94923 12.4776C2.81905 12.6078 2.81905 12.8188 2.94923 12.949C3.0794 13.0792 3.29046 13.0792 3.42063 12.949L7.89834 8.47131L12.376 12.949Z",
    fill: "#2167AE"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/Close.fa44eb75a0d548ded199e89383517b97.svg";
export { ForwardRef as ReactComponent };